// main page
import {fn_currMenuGroupList} from "./FnBodyMenu";
import {notice_list} from "http/SettingConn";

export function fn_commonPrevPage(rootStore){
    const pageInfo = rootStore.pageStore.getPagingInfo;
    if( pageInfo.page_no-1 != 0 )
        rootStore.pageStore.setPagingInfo('page_no',pageInfo.page_no-1)
}

export function fn_commonNextPage(rootStore){
    const pageInfo = rootStore.pageStore.getPagingInfo;
    if( pageInfo.page_no+1 <= pageInfo.max_page )
        rootStore.pageStore.setPagingInfo('page_no',pageInfo.page_no+1)
}

export function fn_commonPageSet(rootStore, maxPage){
    rootStore.pageStore.setPagingInfo('page_no', 1);
    rootStore.pageStore.setPagingInfo('max_page', maxPage);
}

export function fn_commonInitPage(rootStore){
    rootStore.pageStore.initPaging();
}

// left page
export function fn_commonLeftPrevPage(rootStore){
    fn_currMenuGroupList(rootStore, null)
    const pageInfo = rootStore.pageStore.getLeftPagingInfo;
    if( pageInfo.page_no-1 != 0 )
        rootStore.pageStore.setLeftPagingInfo('page_no',pageInfo.page_no-1)
}

export function fn_commonLeftNextPage(rootStore){
    fn_currMenuGroupList(rootStore, null)
    const pageInfo = rootStore.pageStore.getLeftPagingInfo;
    if( pageInfo.page_no+1 <= pageInfo.max_page )
        rootStore.pageStore.setLeftPagingInfo('page_no',pageInfo.page_no+1)
}

export function fn_commonLeftPageSet(rootStore, maxPage){
    rootStore.pageStore.setLeftPagingInfo('page_no', 1);
    rootStore.pageStore.setLeftPagingInfo('max_page', maxPage);
}

export function fn_commonLeftInitPage(rootStore){
    rootStore.pageStore.initLeftPaging();
}

// notice page
export function fn_noticeLeftPrevPage(rootStore){
    const pageInfo = rootStore.settingStore.getNoticePagingInfo;
    if( Number(pageInfo.currentPage) -1 != 0 ){
        rootStore.settingStore.setNoticePagingInfo('currentPage',Number(pageInfo.currentPage) -1)
        notice_list(rootStore, Number(pageInfo.currentPage) -1)
    }
}

export function fn_noticeLeftNextPage(rootStore){
    const pageInfo = rootStore.settingStore.getNoticePagingInfo;
    if( Number(pageInfo.currentPage) +1 <= pageInfo.maxPage ){
        rootStore.settingStore.setNoticePagingInfo('currentPage',Number(pageInfo.currentPage) +1)
        notice_list(rootStore, Number(pageInfo.currentPage) +1)
    }
}
